// extracted by mini-css-extract-plugin
export var details = "_ld-0";
export var inspectorPopover = "_ld-1";